import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/[locale]/template.tsx");
